import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body } from '@swyftx/aviary/atoms/Typography';
import { MarginHistoricOrder } from '@swyftx/margin/build/types';

import { MarginInstrument } from '@routes/SwyftxMargin/components/General';

import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import { useMarginInstruments } from 'src/lib/margin/hooks/instruments';

type Props = {
  order?: MarginHistoricOrder;
};

const MarginHistoryTableInstrumentSide: React.FC<Props> = observer(({ order }) => {
  const { t } = useTranslation('margin');
  const { getMarketById } = useMarginInstruments();

  const title = useMemo(() => {
    if (!order) return null;

    return (
      <Body color='primary' weight='bold'>
        {t(`tradeStatus.${order.status}` as any)}
      </Body>
    );
  }, [order, t]);

  const subTitle = useMemo(
    () =>
      order ? (
        <Body size='small' color='secondary' className='whitespace-nowrap'>
          {t(`tradeSide.${order?.side}` as any)} •{' '}
          {DateTime.fromMillis(order.dateTime || 0)
            .toFormat('hh:mm a')
            .toUpperCase()}
        </Body>
      ) : null,
    [order, t],
  );

  if (!order) return null;

  return (
    <FlexLayout justifyContent='start' alignItems='center' spacing={8}>
      <MarginInstrument market={getMarketById(order.marketUuid)} size='medium' showMarketSymbol={false} />
      <FlexLayout direction='column'>
        {title}
        {subTitle}
      </FlexLayout>
    </FlexLayout>
  );
});

export { MarginHistoryTableInstrumentSide };
